import script from "./PopupTool5.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupTool5.vue?vue&type=script&setup=true&lang=js"

import "./PopupTool5.vue?vue&type=style&index=0&id=44f8b1ea&lang=scss&scoped=true"

import exportComponent from "D:\\phpstudy_pro\\WWW\\qianpaiyun\\v2_2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f8b1ea"]])

export default __exports__